export default (snakeCaseString) => {
    return snakeCaseString
        .replace('_', ' ')
        .split(' ')
        .map(substring => substring.charAt(0).toUpperCase() + substring.slice(1, substring.length))
        .join(' ');
};



// WEBPACK FOOTER //
// ./src/Assets/components/Utility/filters/humanise.js